import React from 'react';
import componentProps, { ComponentProps } from '../../helpers/componentProps';
import { applyComponentTheme } from '../../theme';
import { StyledImg } from './styles';

type LazyImgProps = {
  src: string;
  alt?: string;
  height?: number;
  width?: number;
  shouldEagerLoad?: boolean;
  focusable?: boolean;
} & ComponentProps;

const LazyImg: React.FC<LazyImgProps> = ({
  src,
  alt,
  height,
  width,
  shouldEagerLoad,
  focusable = true,
  ...props
}) => {
  const isFocusable = focusable ? {tabIndex: 0} : undefined
  return (
    <StyledImg
      src={src}
      alt={alt}
      height={height}
      width={width}
      loading={shouldEagerLoad ? 'eager' : 'lazy'}
      {...isFocusable}
      {...componentProps(props)}
    />
  );
};

export default applyComponentTheme(LazyImg, 'LazyImg');
